export function useTrackEvent(event, params = {}) {
  if (import.meta.client) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
  }
}
